/**
 * Age range thresholds for secret age distribution buckets
 * Each threshold represents the maximum age (in days) for that bucket
 * Used consistently across both live and historical secret scoring
 */
export const AGE_THRESHOLDS = {
  m1_31: 31,
  m2_59: 59,
  m3_90: 90,
  m4_120: 120,
  m5_151: 151,
  m6_181: 181,
  m7_212: 212,
  m8_243: 243,
  m9_273: 273,
  m10_304: 304,
  m11_334: 334,
  m12_365: 365,
} as const;
